export enum ValidationStorageKey {
  FLEET_VALIDATION = 'fleetValidation',
}
